export const SIGN_IN = 'Signed In';
export const SIGN_UP = 'Signed Up';

export const SEARCH = 'Search';
export const VIEWED_PRODUCT = 'Viewed Product';
export const VIEWED_PRODUCT_GA = 'Product Viewed';

export const BOOKED_ITEM = 'Booked Item';
export const BOOKED_ITEM_GA = 'Order Completed';
export const BOOKED_GIFT = 'eGiftCard Booked Item';
export const BOOKED_SUBSCRIPTION = 'Subscription Booked Item';

export const CHECKED_OUT_ITEM = 'Checked Out Product';
export const CHECKED_OUT_ITEM_GA = 'Checkout Started';
export const CHECKED_OUT_GIFT = 'Checked Out eGiftCards';
export const CHECKED_OUT_SUBSCRIPTION = 'Checked Out Subscription';

export const CHANGE_BOOKING_STATUS = 'Booking Status Changed';
